import { createContext } from "react";

export const DrilldownDepthContext = createContext(0);
